import { Grid } from "@mui/material";
import type { BusinessInformationStepSchema } from "Components/Onboarding/BusinessEntity/Steps/BusinessInformationStep/BusinessInformationStepContent";
import { ValuesBox } from "Components/Onboarding/shared/ValuesBox";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import { Resources, useResource } from "Translations/Resources";
import type { Control } from "react-hook-form";

type BusinessAddressFormFieldsProps = {
  control: Control<BusinessInformationStepSchema>;
};

export const BusinessAddressFormFields = ({
  control,
}: BusinessAddressFormFieldsProps) => {
  const { t } = useResource();

  return (
    <ValuesBox
      title={t(Resources.Common.Address.Type.Headquarters)}
      hideDivider
    >
      <div>
        <FormInput
          disabled
          control={control}
          name="address.street"
          label={t(Resources.Common.Address.Street)}
        />
        <Grid container spacing={3}>
          <Grid size={{ xs: 6 }}>
            <FormInput
              disabled
              control={control}
              name="address.streetNumber"
              label={t(Resources.Common.Address.StreetNumber)}
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <FormInput
              disabled
              control={control}
              name="address.orientationNumber"
              label={t(Resources.Common.Address.OrientationNumber)}
            />
          </Grid>
        </Grid>
        <FormInput
          disabled
          control={control}
          name="address.municipality"
          label={t(Resources.Common.Address.Municipality)}
        />
        <FormInput
          disabled
          control={control}
          name="address.postalCode"
          label={t(Resources.Common.Address.PostalCode)}
          mask="000 00"
        />
      </div>
    </ValuesBox>
  );
};
